import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Solution(props) {
  return (
    <div className="services_solution  p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <div className="example" data-text="Cloud Solutions">
              <h2>Maximize Value and ROI With Our Cloud Management Services</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <p>
              We specialize in optimizing cloud infrastructure & help your
              business transform for the future with our cloud and artificial
              intelligence expertise. Our developers use cutting-edge design and
              development approaches to create faultless cloud solutions that
              provide unparalleled scalability. Partnering with us not only
              helps you save money, and time, and focus more on operational
              outcomes.
            </p>
            <p>
              Our Managed Cloud Services take care of functionality, security,
              and privacy issues that come up from time to time and could
              prevent you from using a hyperscale cloud. You will experience
              improved security and a higher caliber of service with us.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let's Connect!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Solution;
